export function applyPrefillToExercises(exercises, prefill) {
  if (!prefill?.exercise_patches?.length) return exercises;

  const next = exercises.map((ex) => ({
    ...ex,
    sets: ex.sets.map((s) => ({ ...s })),
  }));

  prefill.exercise_patches.forEach((patch) => {
    const ex = next[patch.index];
    if (!ex) return;
    (patch.sets || []).forEach((setPatch) => {
      const set = ex.sets[setPatch.index];
      if (!set) return;
      Object.assign(set, setPatch.patch);
    });
  });

  return next;
}

export function formatActivitySummary(activity) {
  if (!activity) return "";
  const parts = [];
  if (activity.distance_m >= 1000) {
    parts.push(`${(activity.distance_m / 1000).toFixed(2)} km`);
  } else if (activity.distance_m) {
    parts.push(`${activity.distance_m} m`);
  }
  if (activity.duration_min) {
    parts.push(`${activity.duration_min} min`);
  }
  if (activity.average_watts) {
    parts.push(`${Math.round(activity.average_watts)} W moy.`);
  }
  return parts.join(" · ") || activity.type || "Activité";
}

export const FITNESS_PROVIDER_LABELS = {
  strava: "Strava",
  garmin: "Garmin",
};